import { render, staticRenderFns } from "./size-choose.vue?vue&type=template&id=796a23dc&scoped=true"
import script from "./size-choose.vue?vue&type=script&lang=js"
export * from "./size-choose.vue?vue&type=script&lang=js"
import style0 from "./size-choose.vue?vue&type=style&index=0&id=796a23dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a23dc",
  null
  
)

export default component.exports